import {
  Component,
  Inject,
  OnInit,
  Optional,
  PLATFORM_ID,
  Renderer2,
} from "@angular/core";

import { ProductSlider } from "../../../shared/data/slider";
import { CategorySlider } from "../../../shared/data/slider";
import { Product } from "../../../shared/classes/product";
import { ProductService } from "../../../shared/services/product.service";
import { CommonService } from "../../../shared/services/common.service";
import { CategoriesService } from "../../../shared/services/categories";
import { MasterApiService } from "src/app/shared/services/master-api.service";
import { Router } from "@angular/router";
import { REQUEST } from "@nguniversal/express-engine/tokens";
import { Request } from "express";
import { isPlatformBrowser } from "@angular/common";
@Component({
  selector: "app-fashion-one",
  templateUrl: "./fashion-one.component.html",
  styleUrls: ["./fashion-one.component.scss"],
})
export class FashionOneComponent implements OnInit {
  public products: Product[] = [];
  public all_items: Product[] = [];
  public attachments_items: Product[] = [];

  public lastCategoriesOffers: any[] = [];
  public lastProductsOffers: any[] = [];
  public lastInrademarksOffers: any[] = [];
  public lastInSliderOffers: any[] = [];
  public test: any[] = [];
  public lastInSliderOffersdatadone: boolean = false;
  public lastCategoriesOffersdatadone: boolean = false;
  public lastProductsOffersdatadone: boolean = false;
  public lastInrademarksOffersdatadone: boolean = false;
  public sliderdatadone: boolean = false;
  public categoriesdatadone: boolean = false;
  public brandsdatadone: boolean = false;
  public bestsellerdatadone: boolean = false;
  public newdatadone: boolean = false;
  public attachments_itemsdone: boolean = false;

  public categories: any[] = [];
  public categoriestest: any[] = [];
  public categoriestestDesktop: any[] = [];

  public brands: any[] = [];
  public brandstest: any[] = [];
  public productCollections: any[] = [];
  urlimage = "";
  slideUrlimage = "";
  servicesUrlimage = "";
  brandUrlimage = "";
  allNewestItems: any = [];
  allBestSellerItems: any;
  offerda: any;
  hostName: string = "";
  public _lang_code =
    localStorage.getItem("front-lang") != null
      ? localStorage.getItem("front-lang")
      : "ar";

  organizationSchema: any;

  // loading
  constructor(
    private categoryService: CategoriesService,
    public productService: ProductService,
    private Common: CommonService,
    private MasterApiService: MasterApiService,
    private _Router: Router,
    public renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object,

    @Optional() @Inject(REQUEST) private request: Request
  ) {
    this.Common.removeLinkTags(this.renderer);

    let Subtitle: string = this._lang_code == "ar" ? "الرئيسية" : "Home";
    this.Common.setTitle(Subtitle, true, false, "fasionone");
    this.hostName = this.Common.getDomainFromUrl();
    this.Common.addLinkTag(
      this.renderer,
      "canonical",
      `https://${this.hostName}/`
    );
    this.MasterApiService.getCurrentDataContact().subscribe(
      (dataContact) => {
        if (!dataContact) {
          //console.error("Data contact information is undefined or null");
          return;
        }

        const mobileNumberFromApi = dataContact["mobile"];
        let mobileNumber = "";
        if (mobileNumberFromApi) {
          const firstNumberOfMobileNumber = Array.from(mobileNumberFromApi)[0];
          if (
            firstNumberOfMobileNumber == "0" ||
            firstNumberOfMobileNumber == "+"
          ) {
            mobileNumber = dataContact["mobile"];
          } else {
            mobileNumber = "0" + dataContact["mobile"];
          }
        } else {
          //console.error("Mobile number is undefined or null");
        }

        this.organizationSchema = {
          "@context": "https://schema.org",
          "@type": "Organization",
          name: dataContact.front_name,
          url: `https://www.${this.Common.getDomainFromUrl()}`,
          logo:
            this.MasterApiService.masterData.img_url +
            "/" +
            "front_images/" +
            dataContact.front_logo,
          contactPoint: [
            {
              "@type": "ContactPoint",
              telephone: mobileNumber,
              contactType: "customer service",
              areaServed: "Worldwide",
              availableLanguage: ["English", "Arabic"],
            },
          ],
          sameAs: [
            dataContact.facebook,
            dataContact.email,
            dataContact.instagram,
            dataContact.app_url_ios,
            dataContact.app_url_android,
          ].filter((value) => value),
        };

        // //console.log("organizationSchema", this.organizationSchema);
        localStorage.setItem(
          "paymentInfo",
          JSON.stringify(this.Common.getAllPaymentMethods(dataContact))
        );
      },
      (error) => {
        //console.error("Error fetching contact info", error);
      }
    );

    this.productService.getProducts.subscribe((response) => {
      this.products = response.filter((item) => item.type == "fashion");
      // Get Product Collection
      this.products.filter((item) => {
        item.collection.filter((collection) => {
          const index = this.productCollections.indexOf(collection);
          if (index === -1) this.productCollections.push(collection);
        });
      });
    });
    this.urlimage = this.Common._ImageUrl + "products/thumbs/";
    this.slideUrlimage = this.Common._ImageUrl + "banners/";

    this.servicesUrlimage = this.Common._ImageUrl + "services/";
    this.brandUrlimage = this.Common._ImageUrl + "trademarks/";
  }
  public CategorySliderConfig: any = CategorySlider;
  public ProductSliderConfig: any = ProductSlider;

  public sliders = [
    {
      title: "",
      subTitle: "",
      image: "assets/images/slider/loader12.gif",
    },
  ];
  public allsliders: any[] = [];

  // Collection banner
  public collections = [
    {
      image: "assets/images/collection/fashion/1.jpg",
      save: "",
      title: "",
      width: "width:100%!important; padding : 5px;",
    },
    {
      image: "assets/images/collection/fashion/2.jpg",
      save: "",
      title: "",
      width: "width:50%!important; padding : 5px; ",
    },
    {
      image: "assets/images/collection/fashion/2.jpg",
      save: "",
      title: "",
      width: "width:50%!important; padding : 5px; ",
    },
  ];

  // Blog
  public blog = [
    {
      image: "assets/images/blog/1.jpg",
      date: "25 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image: "assets/images/blog/2.jpg",
      date: "26 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image: "assets/images/blog/3.jpg",
      date: "27 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
    {
      image: "assets/images/blog/4.jpg",
      date: "28 January 2018",
      title: "Lorem ipsum dolor sit consectetur adipiscing elit,",
      by: "John Dio",
    },
  ];

  // Logo
  public logo = [
    {
      image: "assets/images/logos/1.png",
    },
    {
      image: "assets/images/logos/2.png",
    },
    {
      image: "assets/images/logos/3.png",
    },
    {
      image: "assets/images/logos/4.png",
    },
    {
      image: "assets/images/logos/5.png",
    },
    {
      image: "assets/images/logos/6.png",
    },
    {
      image: "assets/images/logos/7.png",
    },
    {
      image: "assets/images/logos/8.png",
    },
  ];

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.getHomeProducts();
      this.getBestSellerProducts();
      this.getNewestProducts();
      this.getHomeSlide();
      this.getLastAllOffers();
      this.getMainCategories();
      this.getAllBrands();
    }
  }

  getHomeProducts() {
    this.productService.getHomeProducts().subscribe((products) => {
      if (products.data) {
        this.all_items = products.data;
        this.filterAttachmentsProducts();
      }
    });
  }
  getBestSellerProducts() {
    this.bestsellerdatadone = false;
    this.productService
      .getModeSellerProducts(null, "best_seller", 10)
      .subscribe((data) => {
        if (data.data) {
          this.allBestSellerItems = data.data;
        }
        this.bestsellerdatadone = true;
      });
  }
  getNewestProducts() {
    this.newdatadone = false;
    this.productService
      .getModeSellerProducts(null, "new", 10)
      .subscribe((products) => {
        if (products.data) {
          this.allNewestItems = products.data;
        }
        this.newdatadone = true;
      });
  }

  filterAttachmentsProducts() {
    this.attachments_items = [];
    this.attachments_itemsdone = false;
    for (let iii = 0; iii < this.all_items.length; iii++) {
      if (this.all_items[iii]["attachment_id"] > 0) {
        this.attachments_items.push(this.all_items[iii]);
        this.attachments_itemsdone = true;
      }
    }
  }

  getHomeSlide() {
    this.sliderdatadone = false;
    this.Common.getHomeSlider().subscribe((slides) => {
      if (slides.data) {
        this.allsliders = slides.data;
        if (this.allsliders.length > 0) {
          this.sliders = [];
          for (let i = 0; i < this.allsliders.length; i++) {
            let obj = {
              title: this.allsliders[i].title,
              subTitle: this.allsliders[i].ser_name,
              image: this.slideUrlimage + this.allsliders[i].image,
              url: this.allsliders[i].url,
              type: this.allsliders[i].type,
              url_type: this.allsliders[i].url_type,
            };
            this.sliders.push(obj);
          }
        }
      }
      this.sliderdatadone = true;
    });
  }

  putDataInTank(data: any, offer: string, offersTank: any[]) {
    this.test = [];
    this.test = data.data[offer];
    if (this.test?.length > 0) {
      for (let ii = 0; ii < this.test.length; ii++) {
        let obj = {
          id: this.test[ii]["id"],
          offer_id: this.test[ii]["offer_on_id"],
          title: this.test[ii]["title"],
          offer_on: this.test[ii]["offer_on"],
          product_title: this.test[ii]["product_title"],
          img: this.test[ii]["image"],
          image: `${this.Common._ImageUrl}${this.test[ii]["mode"]}/${this.test[ii]["image"]}`,
          width:
            "width:" +
            this.test[ii]["offer_width"] +
            "%!important; margin-bottom:0px !important;" +
            (this.test[ii]["offer_width"] == 100
              ? "padding: 5px 0px;"
              : "padding: 5px;"),
          offer_end_date: this.test[ii]["offer_end_date"]
            ? this.test[ii]["offer_end_date"]
            : "",
          show_end_date: this.test[ii]["show_end_date"]
            ? this.test[ii]["show_end_date"]
            : "",
        };
        offersTank.push(obj);
      }
    }
  }

  getLastAllOffers() {
    this.lastCategoriesOffers = [];
    this.lastInSliderOffers = [];
    this.lastProductsOffers = [];
    this.lastInrademarksOffers = [];
    this.lastCategoriesOffersdatadone = false;
    this.lastInSliderOffersdatadone = false;
    this.lastInrademarksOffersdatadone = false;
    this.lastProductsOffersdatadone = false;
    this.Common.getOffersList().subscribe((data) => {
      if (data.data) {
        this.putDataInTank(data, "in_slider", this.lastInSliderOffers);
        this.putDataInTank(data, "in_last_products", this.lastProductsOffers);
        this.putDataInTank(data, "in_categories", this.lastCategoriesOffers);
        this.putDataInTank(data, "in_trademarks", this.lastInrademarksOffers);
      } else {
        this.lastCategoriesOffers = [];
        this.lastCategoriesOffers = [];
        this.lastCategoriesOffers = [];
        this.lastCategoriesOffers = [];
        this.test = [];
      }
      this.lastCategoriesOffersdatadone = true;
      this.lastInSliderOffersdatadone = true;
      this.lastInrademarksOffersdatadone = true;
      this.lastProductsOffersdatadone = true;
    });
  }
  // get Main category
  getMainCategories() {
    this.categories = [];
    this.categoriestest = [];
    this.categoriesdatadone = false;
    this.categoryService.getChildCategories(0).subscribe((data) => {
      if (data.data) {
        this.categories = data.data;
        for (let i = 0; i < this.categories.length; i = i + 2) {
          this.categoriestest.push([
            this.categories[i],
            this.categories[i + 1],
          ]);
        }
        for (let i = 0; i < this.categories.length; i = i + 1) {
          this.categoriestestDesktop.push([this.categories[i]]);
        }
      }
      this.categoriesdatadone = true;
    });
  }
  // get brands
  getAllBrands() {
    this.brands = [];
    this.brandstest = [];
    this.brandsdatadone = false;
    this.Common.getAllBrands("").subscribe((data) => {
      if (data.data) {
        this.brands = data.data;
        if (this.brands.length > 0) {
          for (let i = 0; i < this.brands.length; i = i + 2) {
            this.brandstest.push([this.brands[i], this.brands[i + 1]]);
          }
        }
      } else {
        this.brands = [];
      }
      this.brandsdatadone = true;
    });
  }

  // Product Tab collection
  getCollectionProducts(collection) {
    return this.products.filter((item) => {
      if (item.collection.find((i) => i === collection)) {
        return item;
      }
    });
  }
}
